const s = (a) => a, e = (a) => a;
export {
  e as a,
  s as b
};
//# sourceMappingURL=jwtScopes-Dudgipf5.js.map
